import { ItemDescription, ItemTitle } from 'components/Product/Atoms/Feature';
import { cloneElement } from 'react';
import styled from 'styled-components';
import { ItemCommonComponentContainer } from './ItemVideoComponent';

interface Props {
  featureTitle: string;
  featureDescription?: string[];
  customComponent?: React.ElementType;
  locale: string;
}

const ItemCustomComponent = ({
  featureTitle,
  featureDescription,
  customComponent: CustomComponent,
  locale,
}: Props) => {
  return (
    <ItemCustomComponentContainer>
      <ItemTitle>{featureTitle}</ItemTitle>
      {CustomComponent && (
        <div className="custom-wrapper">
          {cloneElement(<CustomComponent />, { locale })}
        </div>
      )}
      {featureDescription &&
        featureDescription.length !== 0 &&
        featureDescription.map(fd => (
          <ItemDescription className="item-desc" key={fd}>
            {fd}
          </ItemDescription>
        ))}
    </ItemCustomComponentContainer>
  );
};

export default ItemCustomComponent;

const ItemCustomComponentContainer = styled(ItemCommonComponentContainer)`
  .custom-wrapper,
  .item-desc {
    margin-top: 8px;
  }
`;
